export default __webpack_public_path__ + "media/grant.001b5e51.jpg";